import React from 'react';
import { connect } from 'react-redux';
import LeftColumn from './left-column/left-column';
import RightColumn from './right-column/right-column';
import { CircularProgress } from 'material-ui';
import scrollTo from 'scroll-to-element';
import { getProductDetails as getProductDetailsAction } from '../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
const propTypes = {
  getProductDetails: React.PropTypes.func,
  params: React.PropTypes.object,
  productDoesnotExistInDoc: React.PropTypes.bool,
  isProductEmpty: React.PropTypes.bool,
  ratePackageIndex: React.PropTypes.number,
  loading: React.PropTypes.bool,
};
class Product extends React.Component {
  componentDidMount() {
    const { params, getProductDetails } = this.props;
    getProductDetails(params.collection || 'contract', params.contractId, params.productId, params.ratePackage);
    const scrollToAnchor = () => {
      if (window.location.hash) {
        const element = document.querySelector(window.location.hash);
        if (element) scrollTo(window.location.hash, { offset: -70 });
        if (element.onClick) element.click();
      }
    };
    scrollToAnchor();
    window.onhashchange = scrollToAnchor;
  }
  componentWillReceiveProps(nextProps) {
    const { params, getProductDetails} = nextProps;
    if (this.props.params !== nextProps.params) getProductDetails(params.collection || 'contract', params.contractId, params.productId, params.ratePackage);
  }
  render() {
    const { productDoesnotExistInDoc, ...extraProps } = this.props;
    if (this.props.loading) {
      return (
        <div style={{ textAlign: 'center', paddingTop: '56px' }}>
          <CircularProgress size={100} thickness={7}/>
        </div>
      );
    }
    if (productDoesnotExistInDoc) {
      return (
        <div style={{ marginTop: '50px', textAlign: 'center', fontSize: '20px' }}>
          This product does not exist in this document.
        </div>
      );
    }
    return (
      <div className="product-column-flex">
        <LeftColumn {...extraProps} />
        <RightColumn {...extraProps} />
      </div>
    );
  }
}
Product.propTypes = propTypes;

export default connect(({ contracting }) => {
  const rightSideContent = contracting.contractActivitiesProducts.toJS().rightSideContent;
  const allFields = ['extras', 'offers', 'seasons', 'seasonRates', 'blackouts', 'productPolicy', 'allocation'];
  const isProductEmpty = allFields.every(key => rightSideContent[key] && !(rightSideContent[key].length));
  return ({
    loading: contracting.contractActivitiesProducts.get('contentLoading'),
    ratePackageIndex: rightSideContent.ratePackageIndex,
    isProductEmpty,
  });
}, {
  getProductDetails: getProductDetailsAction,
})(Product);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/product.jsx